/**
 * Generated runtime TestId mirror for frontend/src/components/shared/FilterPanel.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const FilterPanelTestIds = {
  btnFilterApply: "btn-filter-apply",
  btnFilterClearAll: "btn-filter-clear-all",
  filterPanel: "filter-panel",
  filterPanelTitle: "filter-panel-title",
  any: (root: string) => `${root}-any`,
  false: (root: string) => `${root}-false`,
  null: (root: string) => `${root}-null`,
  true: (root: string) => `${root}-true`,
  attrNull: (def_name: string) => `attr-${def_name}-null`,
  inlineMultipicker: (filterKey: string) => `inline-multipicker-${filterKey}`,
  inlineMultipickerPrefix: () => "inline-multipicker-" as TestIdPrefix,
  input: (filterKey: string) => `input-${filterKey}`,
  inputPrefix: () => "input-" as TestIdPrefix,
  inputAttr: (paramKey: string) => `input-attr-${paramKey}`,
  inputAttrPrefix: () => "input-attr-" as TestIdPrefix,
  inputDaterangeFrom: (groupKey: string) => `input-daterange-${groupKey}-from`,
  inputDaterangeTo: (groupKey: string) => `input-daterange-${groupKey}-to`,
  multipicker: (pickerKey: string) => `multipicker-${pickerKey}`,
  multipickerPrefix: () => "multipicker-" as TestIdPrefix,
  multipickerSearch: (pickerKey: string) => `multipicker-search-${pickerKey}`,
  multipickerSearchPrefix: () => "multipicker-search-" as TestIdPrefix,
  section: (filterKey: string) => `section-${filterKey}`,
  sectionPrefix: () => "section-" as TestIdPrefix,
  sectionAttr: (def_name: string) => `section-attr-${def_name}`,
  sectionAttrPrefix: () => "section-attr-" as TestIdPrefix,
  sectionDaterange: (groupKey: string) => `section-daterange-${groupKey}`,
  sectionDaterangePrefix: () => "section-daterange-" as TestIdPrefix,
  attr: (def_name: string, v_code: string) => `attr-${def_name}-${v_code}`,
  attrPrefix: () => "attr-" as TestIdPrefix,
  filterOption: (filterKey: string, v: string) => `filter-option-${filterKey}-${v}`,
  filterOptionPrefix: () => "filter-option-" as TestIdPrefix
} as const;
